import { useAtom } from "jotai"

import { isSearchPanelOpenAtom } from "~/components/ui/Panels/Search/store"

export function useIsSearchPanelOpen() {
  return useAtom(isSearchPanelOpenAtom)
}
